<div
  [style.max-height]="templateType === TemplateType.TASK_TEMPLATE ? '60vh' : 'unset'"
  [class.scroll]="templateType === TemplateType.TASK_TEMPLATE"
  [perfectScrollbar]="{ wheelPropagation: false }"
  class="px-10 py-1"
>
  <form *ngIf="form" [formGroup]="form" class="mb-10">
    <mat-form-field appearance="fill" class="w-100 mb-5">
      <mat-label>Code</mat-label>
      <input matInput formControlName="code" />
      <mat-error *ngIf="hasError('code', 'required')">{{
        getErrorMessage('Code', 'required')
      }}</mat-error>
      <mat-error *ngIf="hasError('code', 'duplicate')">{{
        getErrorMessage('Code', 'duplicate')
      }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-100 mb-5">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description"></textarea>
      <mat-error *ngIf="hasError('description', 'required')">{{
        getErrorMessage('Description', 'required')
      }}</mat-error>
    </mat-form-field>
    <div class="d-flex align-items-end justify-content-between">
      <div>
        <div class="d-flex align-items-center w-100 mb-5">
          <mat-label class="mr-4">Trigger Follow-up</mat-label>
          <mat-slide-toggle formControlName="triggerFollowUp"></mat-slide-toggle>
        </div>
        <div class="d-flex align-items-center w-100">
          <mat-label class="mr-4">Active</mat-label>
          <mat-slide-toggle formControlName="isActive"></mat-slide-toggle>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <button
          *ngIf="index"
          mat-raised-button
          class="btn btn-light mr-4"
          (click)="cancelBlockerUpdate($event)"
        >
          Cancel
        </button>
        <button
          mat-raised-button
          style="width: 130px"
          class="btn btn-primary"
          (click)="addBlocker($event)"
          [disabled]="mode === 'view'"
        >
          {{ index ? 'Update' : 'Add' }} Blocker
        </button>
      </div>
    </div>
  </form>
  <div class="border rounded p-4">
    <div *ngIf="!blockers?.length" class="font-weight-bold text-center w-100">
      There is no blocker added!
    </div>
    <ng-container *ngIf="blockers?.length">
      <div class="row bg-light border rounded font-weight-bold m-0 mb-4 p-2 w-100">
        <div class="col-2">Code</div>
        <div class="col-8">Description</div>
        <div class="col-2">Actions</div>
      </div>
      <div
        *ngFor="let blocker of blockers; let idx = index"
        class="row border-bottom m-0 mb-2 p-2 w-100"
      >
        <div class="col-2">{{ blocker.code }}</div>
        <div class="col-8">{{ blocker.description }}</div>
        <div class="col-2" *ngIf="mode !== 'view'">
          <button
            class="btn btn-icon btn-sm btn-light btn-hover-primary mr-1"
            [matTooltip]="'TABLE.UPDATE' | translate"
            (click)="updateBlocker($event, idx)"
          >
            <span
              inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
              class="svg-icon svg-icon-md svg-icon-primary"
            ></span>
          </button>
          <button
            class="btn btn-icon btn-sm btn-light btn-hover-danger"
            [matTooltip]="'TABLE.DELETE' | translate"
            (click)="deleteBlocker($event, idx)"
          >
            <span
              inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
              class="svg-icon svg-icon-md svg-icon-danger"
            ></span>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
